import { ModalPopup, sectionHeaderLarge } from '@aon/aon-tws-common-ui';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import contentConstants from '../../../contentConstants';
import { UserListTable } from './UserListTable';
import { ActionCreators } from '../../../store/SurveyCopyModalStore';

const SectionHeaderLarge = styled.p`
	${sectionHeaderLarge};
`;
SectionHeaderLarge.displayName = 'SectionHeaderLarge';

const ModalInstructionText = styled.p`
	color: #444444;
	font-family: Montserrat;
	font-size: 13.5px;
	font-weight: 600;
	text-align: center;
`;
ModalInstructionText.displayName = 'ModalInstructionText';

const DisplayWrapper = styled.div`
	display: relative;
	width: 100%;
`;
DisplayWrapper.displayName = 'DisplayWrapper';

export interface ICopySurveyModalProps {
	isOpen: boolean;
	selectedSurveyId: number;
	onClose: () => void;
}

export const CopySurveyModal = (props: ICopySurveyModalProps) => {
	const [selectedUserIds, setUserIds] = useState<number[]>([]);
	const dispatch = useDispatch();

	function onDone() {
		if (selectedUserIds.length > 0) {
			dispatch(ActionCreators.BulkCopySurvey(props.selectedSurveyId, selectedUserIds));
		}
		handleClose();
	}

	function handleClose() {
		setUserIds([]);
		props.onClose();
	}

	return (
		<ModalPopup
			isOpen={props.isOpen}
			title={<SectionHeaderLarge>{contentConstants.SURVEY_COPY_MODAL_TITLE}</SectionHeaderLarge>}
			contentfullwidth={true}
			contenthcentered={true}
			onClosed={handleClose}
			primaryButtonText={contentConstants.BUTTONS_FINISH_CLOSE}
			secondaryButtonText={contentConstants.BUTTONS_CANCEL}
			onSubmit={() => onDone()}
		>
			<DisplayWrapper>
				<ModalInstructionText>{contentConstants.SURVEY_COPY_MODAL_CONTENT}</ModalInstructionText>
				<br />
				<UserListTable selectedUserIds={selectedUserIds} setSelectedUserIds={setUserIds} />
			</DisplayWrapper>
		</ModalPopup>
	);
};
